<template>
  <div name="stdapplinf-detail-pg4">
    <div class="row">
      <div class="col-md-2 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['10'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(data.dteempdb) }}</div>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ data.coddomcl }} - {{ data.ti_desdomcl }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="M" :checked="data.codsex === 'M' ? true : false" disabled>
                {{ labels['31'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="F" :checked="data.codsex === 'F' ? true : false" disabled>
                {{ labels['32'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numoffid }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ data.adrissue }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['60'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(data.dteoffid) }}</div>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['70'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codprov }} - {{ data.ti_codprov }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['80'] }}</label>
          <div class="form-control readonly-field-color">{{ data.stamarry }} - {{ data.desc_stamarry }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['90'] }}</label>
          <div class="form-control readonly-field-color">{{ data.stamilit }} - {{ data.desc_stamilit }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['100'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numtaxid }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['110'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numsaid }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['120'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codblood }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['130'] }}</label>
          <div class="form-control readonly-field-color">{{ data.weight }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['140'] }}</label>
          <div class="form-control readonly-field-color">{{ data.height }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['150'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codrelgn }} - {{ data.ti_desrelgn }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['160'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codorgin }} - {{ data.ti_desorgin }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['170'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codnatnl }} - {{ data.ti_desnatnl }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['180'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['190'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numlicid }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['200'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data.dtelicid) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['210'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['220'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numpasid }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['230'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data.dtepasid) }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['240'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numprmid }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['250'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data.dteprmst) }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['260'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data.dteprmen) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg4',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg4.vue?0590a031